module.exports = __webpack_public_path__ + "./images/0aed1e4631eef8384849009cc2ef4b6f.webp";